import { render, staticRenderFns } from "./Frame.vue?vue&type=template&id=9f3c437c&scoped=true"
import script from "./Frame.vue?vue&type=script&lang=ts"
export * from "./Frame.vue?vue&type=script&lang=ts"
import style0 from "./Frame.vue?vue&type=style&index=0&id=9f3c437c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3c437c",
  null
  
)

export default component.exports